import './QuestionYesNo.css'; 
import CustomCheckBox from '../../Components/custom-checkbox/CustomCheckBox';
import { t } from 'i18next';

const QuestionYesNoAnswerWidget = ({ questions, setQuestions, isMobile }) => {

const handleChange = (id, flagValue) => {
    setQuestions(preQuestions =>
        preQuestions.map(question =>
        id === question.id ? { ...question, flag: flagValue } : question
        )
    );
};
    
  return (
    <div className="survey-container">
      <div className="question-group">
        <div className="question-text" style={{backgroundColor: "transparent"}}></div>
        {
          isMobile ? <></>
          :
          <div className="options-question">
            <label className="checkbox-label container-checkbox-label-agree">{t("yes")}</label>
            <label className="checkbox-label container-checkbox-label-disagree">{t("no")}</label>
          </div>
        }
      </div>
      {questions.map((question, index) => (
        <div key={index} className="question-group">
          <div className="question-text"><ul><li style={{listStyleType: "disc"}}>{question.text}</li></ul></div>
          <div className="options-question">
            {
              isMobile ?
              <>
              <CustomCheckBox value={question.flag === true} setValue={() => handleChange(question.id, true)}  text={t("yes")}/>
              <CustomCheckBox value={question.flag === false} setValue={() => handleChange(question.id, false)}  text={t("no")}/>
                </>
              :
              <>
              <CustomCheckBox value={question.flag === true} setValue={() => handleChange(question.id, true)}  text={""}/>
              <CustomCheckBox value={question.flag === false} setValue={() => handleChange(question.id, false)}  text={""}/>
              </>
            }
          </div>
        </div>
      ))}
    </div>
  );
};
export default QuestionYesNoAnswerWidget;